import AntAlert from 'components/ui/base/alert/Alert';
import styled from 'styled-components';

export const Alert = styled(AntAlert)`
    margin-bottom: 0.5rem;
`;
